export const audit = {
	APPROVE: `approve`,
	COMMENTS: `comments`,
	RESET: `reset`,
	REVISE: `revise`,
	SUBMIT: `submit`,
};